import { grillaConfig } from "./../custom.js";
import jQuery from "../modules/jquery/jquery-3.6.1.min.js"
jQuery(document).ready(function($) {
	$('.accordion-heading').click(function() {
		var $this = $(this),
		$container = $this.parents('.accordion'),
		accordion_id = $this.data('accordion'),
		close = false,
		$content = $("#"+accordion_id);

		if (!$content.data('animating')) {
			if ($this.hasClass('active')) {
				close = true;
			}

			$container.find('.accordion-heading, .accordion-content').removeClass('active');
			$container.find('.accordion-content').slideUp({
				duration: grillaConfig.accordion.animationDuration,
				easing: 'linear'
			});

			if (!close) {
				$this.addClass('active');
				$content.slideToggle({
					duration: grillaConfig.accordion.animationDuration,
					easing: 'linear',
					start: function() {
						$content.data('animating', true);
						$content.addClass('active');
					},
					done: function() {
						$content.data('animating', false);
					}
				});
			}
		}
	});

	$('.accordion-heading.active').each(function(i, el) {
		var accordion_id = $(el).data('accordion');
		$('#'+accordion_id).slideDown({
			duration: grillaConfig.accordion.animationDuration,
			done: function() {
				$('#'+accordion_id).clearQueue();
			}
		});
	});
});